import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_DOCUMENT_GENERATOR, ERRORS, AXIOS_REQUESTS, GENERAL_FILES } from '@/constants/store.js'

const actions = {
  async [LOT_DOCUMENT_GENERATOR.ACTIONS.GET_GENERATED_FILE_FOR_LOT] ({ dispatch }, model) {
    const url = `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/fileGenerator/${model.fileType}?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [LOT_DOCUMENT_GENERATOR.ACTIONS.GET_LOT_PROTOCOL] ({ dispatch }, model) {
    const url = `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/fileGenerator/protocol?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [LOT_DOCUMENT_GENERATOR.ACTIONS.ATTACH_LOT_PROTOCOL] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeProcessDocumentation/protocol`,
      model: null
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },

  async [LOT_DOCUMENT_GENERATOR.ACTIONS.GET_LOT_OFFERS_REGISTRY] ({ dispatch }, model) {
    const url = `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/fileGenerator/lotOffersRegistry?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [LOT_DOCUMENT_GENERATOR.ACTIONS.ATTACH_LOT_OFFERS_REGISTRY] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/lotOffersRegistry`,
      model: null
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  }
}

export default {
  namespaced: true,
  actions
}
